import { createContext, useContext, useEffect } from "react";
export const SettingsChangesContext = createContext<(dirty: boolean) => void>(
  () => {},
);
export function useSettingsChanges(dirty: boolean) {
  const setDirty = useContext(SettingsChangesContext);
  useEffect(() => {
    setDirty(dirty);
    return () => setDirty(false);
  }, [dirty, setDirty]);
}
